
import React, {useState, useRef} from 'react'
import axios from 'axios';
import baseUrl from "./BaseUrl";
//import {apiUrl} from "./config";

//import jwt_decode from "jwt-decode";
import { useNavigate, Link } from 'react-router-dom';
import { clearPageFilters } from "../hooks/filterPersistence";
import Loader from "./Loader";
import PropTypes from 'prop-types';
import './navbar.css';
 
const Navbar = () => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [toogleSidebar, setToogleSidebar] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [iframeUrl] = useState(null);
    //const [token, SetToken] = useState(props.token);

    const toggleRef = useRef(null);
    // useEffect(() => {
    //     if (props.token) {
    //       try {
    //         const decoded = jwt_decode(props.token);

    //       } catch (error) {
    //         // Handle invalid token or decoding error
    //         console.error('Error decoding token:', error);
    //       }
    //     }
    //   }, [props.token]);
   

    // const getApplicationList = async () => {
    //     try{
    //         setPopupOpen(true);
           
    //         const response = await axios.get(`${baseUrl}/application-name-list/${cid}`, {
    //             headers: {
    //                 Authorization: `Bearer ${props.token}`
    //             }
    //         });
    //         setPopupOpen(false);
    //         setApplicationList(response.data.data);
    //     }catch (error) {
    //         console.log(error);
    //         setPopupOpen(false);
    //     }
    // }
    const Logout = async () => {
        try {
            setPopupOpen(true);
            await axios.delete(`${baseUrl}/admin/api/logout`);
            navigate("/");
        } catch (error) {
            console.log(error);
            setPopupOpen(false);
        }
    }

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const handleToogleSidebar = () => {
        const value = !toogleSidebar;
        
        if (toggleRef.current) {
            const parentElement = toggleRef.current.closest('.panelbox');
            if (value && parentElement) {
                parentElement.classList.add('collaps-wrap'); // Add class to parent
            }
            if(!value && parentElement){
                parentElement.classList.remove('collaps-wrap'); // Add class to parent
            }
        }
        setToogleSidebar(value);
    }
 
    return (
        
        <div className={`${toogleSidebar ? "collaps-sidebar" : ""} left-sidebar`}>
            {popupOpen && (
                     <Loader /> 
                ) }
        <div className="logo-div">
            <img src={`${process.env.PUBLIC_URL}/images/innerlogo.png`} alt='' width="170" height="70" />
            {/* <div> */}
            <button type="button" ref={toggleRef} onClick={handleToogleSidebar} className="sidebar-collapse-toggle" aria-label="Collapse sidebar"><img src={`${process.env.PUBLIC_URL}/images/menubar.png`} alt="" /></button>
            {/* </div> */}
        </div>
        <nav className={`mainmenu${mobileMenuOpen ? ' is-open' : ''}`} aria-label="Main menu" style={mobileMenuOpen ? {display: 'block'}: {}}>
            <div className="mobilemenu-close">
                <button type="button" onClick={toggleMobileMenu} aria-label="Close menu"><img src={`${process.env.PUBLIC_URL}/images/close_white.png`} alt="" /></button>
            </div>
            <ul onClick={(e) => { const a = e.target.closest && e.target.closest('a'); if (a) clearPageFilters(a.getAttribute('href')); }}>
                <li>
                    <Link to="/dashboard"><img src={`${process.env.PUBLIC_URL}/images/layers.png`} alt='' /> <span>Dashboard</span></Link>
                </li>
                <li>
                    <Link to="/users"><img src={`${process.env.PUBLIC_URL}/images/bx-user.png`} alt='' /> <span>Users</span></Link>
                </li>
                <li>
                    <Link to="/user-subscription"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>User Subscription</span></Link>
                </li>
                <li>
                    <Link to="/user-feedback"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>User Feedback</span></Link>
                </li>
                <li>
                    <Link to="/pauser-support"><img src={`${process.env.PUBLIC_URL}/images/bx-user.png`} alt='' /> <span>Pauser Support</span></Link>
                </li>
                <li>
                    <Link to="/installation-data-statics"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/download.png`} alt='' /> <span>Installation Statistics</span></Link>
                </li>
                <li>
                    <Link to="/active-users"><img src={`${process.env.PUBLIC_URL}/images/bx-user.png`} alt='' /> <span>Daily active users</span></Link>
                </li>
                <li>
                    <Link to="/unique-users-count"><img src={`${process.env.PUBLIC_URL}/images/bx-user.png`} alt='' /> <span>Most active users</span></Link>
                </li>
                <li>
                    <Link to="/standing-check-sessions"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Standing Checks</span></Link>
                </li>
                <li>
                    <Link to="/user-heart-rate-sessions"><img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt='' /> <span>Alerts</span></Link>
                </li>
                <li>
                    <Link to="/user-pause-count"><img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt='' /> <span>Pauses</span></Link>
                </li>
                <li>
                    <Link to="/continuous-usage-streaks"><img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt='' /> <span>Pause Impact</span></Link>
                </li>
                <li>
                    <Link to="/user-monitor-sessions"><img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt='' /> <span>Monitor Sessions</span></Link>
                </li>
                <li>
                    <Link to="/user-permissions"><img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt='' /> <span>Permissions</span></Link>
                </li>
                <li>
                    <Link to="/user-bio-vitals"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Bio Vitals</span></Link>
                </li>
                <li>
                    <Link to="/user-medicine"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Medicine</span></Link>
                </li>
                <li>
                    <Link to="/user-sleep-sessions"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Sleep Sessions</span></Link>
                </li>
                <li>
                    <Link to="/user-sleep-summary"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Sleep Summary</span></Link>
                </li>
                <li>
                    <Link to="/workout-sessions"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Workouts</span></Link>
                </li>
                <li>
                    <Link to="/workout-records"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Workout Records</span></Link>
                </li>
                <li>
                    <Link to="/report-history"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Report History</span></Link>
                </li>
                <li>
                    <Link to="/event-logs"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>C&C History</span></Link>
                </li>
                <li>
                    <Link to="/cloudwatch-error-logs"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Error Logs</span></Link>
                </li>
                <li>
                    <Link to="/webhook-activity"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Webhook Activity</span></Link>
                </li>
                <li>
                    <Link to="/notifications"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Notifications</span></Link>
                </li>
                <li>
                    <Link to="/delete-user-data"><img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt='' /> <span>Delete User Data</span></Link>
                </li>
                <li>
                    <button type="button" onClick={Logout}><img src={`${process.env.PUBLIC_URL}/images/logout.png`} alt='' /> <span>Log out</span></button>
                </li>
            </ul>
        </nav>
        {!mobileMenuOpen && <div className="mobilemenu" onClick={toggleMobileMenu}>
            <button type="button" onClick={toggleMobileMenu} aria-label="Open menu"><img src={`${process.env.PUBLIC_URL}/images/menubar.png`} alt='' /></button>
        </div>}
        {iframeUrl && (
            <div className="iframe-wrap" >
                <iframe 
                    src={iframeUrl}
                    className="iframe"
                    
                    title="Fullscreen Iframe"
                />
                {/* <a 
                    onClick={closeIframe} 
                    className='iframe-close'
                    >
                    <img src={`${process.env.PUBLIC_URL}/images/bx-x-circle.png`}  alt="Close" title="Close" />
                </a> */}
            </div>
        )}
    </div>
    
    )
}
 
Navbar.propTypes = { access: PropTypes.array };

export default Navbar